
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/truck-parts/[make]/[city]",
      function () {
        return require("private-next-pages/truck-parts/[make]/[city]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/truck-parts/[make]/[city]"])
      });
    }
  